import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppConfig } from './../../app.config';
import { UtomInfos } from '../../services/shared.define';

@Injectable()
export class LoginService {
  public static readonly SignInKind_Conseiller: number = 1001;
  public static readonly SignInKind_Normal: number = 1002;
  public static readonly SignInKind_MultiClient: number = 1003;
  public static readonly SignInKind_ResetPwdOnly: number = 1004;

  private sessionStorageTokenName: string;
  private sessionStorageRefreshTokenName: string;
  private sessionStorageUtomInfos: string;
  private authentificationUrl: string;
  private urlDeconnection: string;
  private urlGetUtomInfos: string;
  private urlGetUtomCoordonnes: string;

  private urlSelectUtom: string;
  private _clients: any[];

  constructor(private _http: HttpClient, private _appConfig: AppConfig) {
    this.sessionStorageTokenName = 'jwt-token';
    this.sessionStorageRefreshTokenName = 'jwt-refresh-token';
    this.sessionStorageUtomInfos = 'utom-infos';
    this.authentificationUrl = this._appConfig.getConfig().nPointAuthService + '/auth/signin';
    this.urlDeconnection = this._appConfig.getConfig().nPointAuthService + '/auth/logout';
    this.urlGetUtomInfos = this._appConfig.getConfig().nPointDeclarations + '/utom/UtomInfos';
    this.urlGetUtomCoordonnes = this._appConfig.getConfig().nPointDeclarations + '/utom/GetUtomCoordonnes';
    this.urlSelectUtom = this._appConfig.getConfig().nPointAuthService + '/auth/switch-client/';
  }

  authentification(email: string, password: string): Observable<any> {
    const loginData = { platForm: 25, login: email, password: password, origin: 2 };
    return this._http.post(this.authentificationUrl, loginData)
      .map(this.extractReturnAuthData)
      .catch(this.handleAuthentificationError);
  }

  getUtomInfos(): Observable<any> {
    return this._http.get(this.urlGetUtomInfos)
  }

  saveUtomInfos(utomInfos: UtomInfos) {
    sessionStorage.setItem(this.sessionStorageUtomInfos, JSON.stringify(utomInfos));
  }

  getUtomInfosfromSessionStorage():UtomInfos {
    return JSON.parse(sessionStorage.getItem(this.sessionStorageUtomInfos));
  }

  private extractReturnAuthData(res: any) {
    return res;
  }

  private handleAuthentificationError(err: HttpErrorResponse) {
    let errMsg: string;
    if (err && (err.error instanceof Error)) {
        errMsg = `${err.status} - ${err.statusText || ''} ${err}`;
    } else if (err && err.error && err.error.message) {
        errMsg = (err.error.message ? err.error.message : err.error.toString());
    } else if (err.status == 400) {
      errMsg = "Identifiant ou mot de passe incorrect";
    }
    return Observable.throw(errMsg);
}

  saveToken(token) {
    sessionStorage.setItem(this.sessionStorageTokenName, token);
  }

  saveRefreshToken(token) {
    sessionStorage.setItem(this.sessionStorageRefreshTokenName, token);
  }

  removeToken() {
    sessionStorage.removeItem(this.sessionStorageTokenName);
  }

  getToken() {
    return sessionStorage.getItem(this.sessionStorageTokenName);
  }

  deconnectFromServer() {
    return this._http.post(this.urlDeconnection, null);
  }

  clearSessionstorage() {
    sessionStorage.clear();
  }

  saveClients(clients) {
    this._clients = clients;
  }

  getClients() {
    return this._clients;
  }

  selectUtom(clientCode) {
    return this._http.get(this.urlSelectUtom + clientCode);
  }

  getUtomCoordonnes() {
    return this._http.get(this.urlGetUtomCoordonnes);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/login/login.service.ts